/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Observable } from 'rxjs';
import { BaseTreeStructureApi } from './BaseTreeStructureApi';

export class ImpactLevelApi extends BaseTreeStructureApi {
  endPoint: string = '/api/admin/impact-levels';

  public logout(): Observable<any> {
    const _routeParams: any = {};
    return this._get('/api/auth/logout', _routeParams);
  }
}
